import {createSubscribableMutator} from 'web-app/react/hooks/create-subscribable-mutator';

import {UpdatePricingGroups} from './update-pricing-groups.mutation';
import type {
    UpdatePricingGroupsMutation,
    UpdatePricingGroupsMutationVariables,
} from './__generated__/update-pricing-groups.mutation.api-types';

export const {
    useSubscribableMutation: useSubscribableUpdatePricingGroupsMutation,
    useSubscribeMutationResult: useSubscribableUpdatePricingGroupsMutationResult,
} = createSubscribableMutator<UpdatePricingGroupsMutation, UpdatePricingGroupsMutationVariables>(UpdatePricingGroups);
